const styles = () => ({
  green: {
    color: 'rgb(54, 196, 128)',
  },

  red: {
    color: 'rgb(196, 74, 54)',
  },

  statusIcon: {
    position: 'relative',
    top: '-1px',
  },

  circularProgress: {
    color: 'white',
    marginRight: 8,
  },

  testMessage: {
    marginRight: 32,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: 8,
    },
  },
});

export default styles;
